import { useState, useEffect } from 'react';
import axios from 'axios';
import { DEFAULT_TECHNICAL_LOG_BOOK_DEFINITION } from '../../../constants/technicalLogBookDefinition';
import { buildTlbHoursOptions } from '../../../utils/tlbCycleCounters';

/**
 * Load TLB hour/Hobbs counter dropdown options (labels from aircraft approved format, values from live usage).
 */
export function useTlbHoursOptions({ open, aircraftId, currentUsageTotals }) {
  const [tlbHoursOptions, setTlbHoursOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !aircraftId) {
      setTlbHoursOptions([]);
      return;
    }

    let cancelled = false;

    const load = async () => {
      setLoading(true);
      try {
        const aircraftRes = await axios.get(`/api/aircraft/${aircraftId}`);
        const aircraft = aircraftRes.data;
        const formatId =
          aircraft?.approvedTechnicalLogBookFormatId?._id ||
          aircraft?.approvedTechnicalLogBookFormatId;

        let definition = DEFAULT_TECHNICAL_LOG_BOOK_DEFINITION;
        try {
          const formatRes = formatId
            ? await axios.get(`/api/technical-log-book-format/${formatId}`)
            : await axios.get('/api/technical-log-book-format/default');
          const format = formatRes.data;
          if (format?.definition && typeof format.definition === 'object') {
            definition = format.definition;
          }
        } catch (err) {
          console.error('Error loading TLB format for hours options:', err);
        }

        const liveValues = currentUsageTotals?.values;
        const options = buildTlbHoursOptions(definition, liveValues);
        if (!cancelled) {
          setTlbHoursOptions(options);
        }
      } catch (err) {
        console.error('Error loading aircraft for TLB hours options:', err);
        if (!cancelled) {
          setTlbHoursOptions(
            buildTlbHoursOptions(DEFAULT_TECHNICAL_LOG_BOOK_DEFINITION, currentUsageTotals?.values)
          );
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [open, aircraftId, currentUsageTotals?.values, currentUsageTotals?.asOnDateTime]);

  return { tlbHoursOptions, tlbHoursOptionsLoading: loading };
}
